import { Injectable } from '@angular/core';
import { CustomizationGroupsEntity, CustomizationSubGroupEntity, MealRecipeCustomization, ModifierGroupsEntity } from '@core/redux/stores';
import * as _ from 'lodash-es';

@Injectable()
export class CustomizationSubgroupService {

  calculateSubGroupPrice(customizationGroup: CustomizationGroupsEntity ):  (CustomizationSubGroupEntity)[] {
    const outputSubGroupEntity: (CustomizationSubGroupEntity)[] = [];
    if (customizationGroup.customizationSubGroups && customizationGroup.customizationSubGroups.length > 0
       && customizationGroup.modifierGroups && customizationGroup.modifierGroups.length > 0) {
      const csgList = customizationGroup.customizationSubGroups;
      let sortIndex = 0;
      csgList.forEach(csg => {
        if (csg.modifierGroupIds && csg.modifierGroupIds.length > 0) {
          const csgmgList = csg.modifierGroupIds;
          const selectedSubGroupEntity: (CustomizationSubGroupEntity)[] = [];
          customizationGroup.modifierGroups.forEach(mg => {
            if (csgmgList.find( csgmg => csgmg === mg.id)) {
              const selectedModifier = mg.selectedModifier;
              const selectedSubModifier = new CustomizationSubGroupEntity();
              selectedSubModifier.modifierGroup = mg;
              if (mg.isSelected && selectedSubModifier.modifierGroup.modifiers.find(m => m.id === selectedModifier )) {
                selectedSubModifier.modifier = _.clone(selectedSubModifier.modifierGroup.modifiers.find(m => m.id === selectedModifier ));
                selectedSubModifier.sortOrder = sortIndex;
                selectedSubModifier.subPrice = selectedSubModifier.modifier.subUnitPrice;
                selectedSubModifier.modifierUnitPrice = selectedSubModifier.modifier.unitPrice;
                selectedSubModifier.discountAmount = selectedSubModifier.modifierUnitPrice - selectedSubModifier.subPrice;
                selectedSubModifier.customizationSubGroupId =  csg.customizationSubGroupId;
                selectedSubGroupEntity.push(selectedSubModifier);
                outputSubGroupEntity.push(selectedSubModifier);
              }
            }
            sortIndex += 1;
          });
          selectedSubGroupEntity.sort(
            (subGroupModifier1, subGroupModifier2) => {
              if (subGroupModifier1.discountAmount > subGroupModifier2.discountAmount) {
                return -1;
              } else if (subGroupModifier1.discountAmount < subGroupModifier2.discountAmount) {
                return 1;
              } else {
                if (subGroupModifier1.sortOrder < subGroupModifier2.sortOrder) {
                  return -1;
                } else if (subGroupModifier1.sortOrder > subGroupModifier2.sortOrder) {
                  return 1;
                } else {
                  return 0;
                }
              }
            }
          );
          let subQuantityRemaining = csg.quantity;
          let anySelected = false;
          selectedSubGroupEntity.forEach(selectedModifier => {
            if (selectedModifier.modifierGroup.isSelected) {
              anySelected = true;
            }
            selectedModifier.quantity = selectedModifier.modifier.quantity !== null ? selectedModifier.modifier.quantity : 1;
            selectedModifier.subQuantity = 0;
          });
          selectedSubGroupEntity.forEach(selectedModifier => {
            if (anySelected) {
              if (selectedModifier.modifierGroup.isSelected) {
                if ( !(subQuantityRemaining <= 0)) {
                  selectedModifier.subQuantity = Math.min(subQuantityRemaining, selectedModifier.quantity);
                  selectedModifier.quantity = selectedModifier.quantity - selectedModifier.subQuantity;
                  subQuantityRemaining -= selectedModifier.subQuantity;
                }
              }
            } else {
              selectedModifier.subQuantity = 1;
              selectedModifier.quantity = 0;
            }
          });
        }
      });
    }
    return outputSubGroupEntity;
  }

  setSelectedModifiers(cg: CustomizationGroupsEntity, customizations: MealRecipeCustomization[]) {
    if ( cg && customizations && customizations.length > 0 && cg.customizationSubGroups && cg.customizationSubGroups.length > 0) {
      const groupOrder = customizations.filter( c => c.customizationGroupId === cg.id);
      cg.modifierGroups.forEach(mg => {
        if ( groupOrder && groupOrder.length > 0 ) {
          const modGroupOrder = groupOrder.filter ( mgOrder => mgOrder.modifierGroupId === mg.id);
          mg.modifiers.forEach(m => {
            if (modGroupOrder) {
              const modifierOrder = modGroupOrder.find( mgo => mgo.modifierId === m.id);
              if (modifierOrder) {
                mg.isSelected = true;
                mg.selectedModifier = modifierOrder.modifierId;
              }
            }
          });
        }
      });
    }
  }

  isModifierExistInSubgroup(customizationGroup: CustomizationGroupsEntity, modifierGroup: ModifierGroupsEntity): boolean {
    let value = false;
      if (customizationGroup.customizationSubGroups && customizationGroup.customizationSubGroups.length > 0) {
        customizationGroup.customizationSubGroups.forEach( csg => {
            if (csg.modifierGroupIds.find( id => id === modifierGroup.id )) {
             value = true;
            }
          }
        );
      }
      return value;
    }
}
